export const WORK_CHUNKS_PER_WORKER = 50;
export const CALL_PROGRESS_CALLBACK_AFTER_COMBINATIONS = 50000;
export const CALL_PROGRESS_CALLBACK_AFTER_NUMBER_OF_RESULTS_REACHED = 10000;
